export enum AuthenticationErrorType {
    ERROR_SIGNIN = "error_signin",
    ERROR_SIGNUP = "error_signup",
    MISSING_INFORMATION = "missing_information",
    PASSWORD_RECOVERY = "password_recovery"
}